module.exports = __webpack_public_path__ + "static/media/chatIcon.9342c2ad.svg";